<template>
  <div :class="['main-grid-container', 'main-div-masternode', stonky && 'stonky-wrapper', labz && 'labz-wrapper']">
    <div v-if="stonky || labz" :class="['fill-abs', (stonky || labz) && 'shake-hover']">
      <img v-if="stonky" class="md-chart" src="./assets/md-chart.png" alt="chart" />
      <img v-if="labz" class="md-chart" src="./assets/fud/pos-equals-xsn.jpg" alt="chart" />
    </div>
    <header class="sul-box-raised-2 sm header-z">
      <div class="nav-container">
        <div class="nav-inner">
          <div class="brand">
            <img class="brand-logo" src="./assets/xsn-logo.png" alt="logo" />
            <h2 class="brand-text">{{labz ? 'SCAMNEEEEEEET' : stonky ? 'StonkNEET' : 'STAKENET' }}<br/><span class="brand-sub-text">MASTERNODE CALC</span></h2>
          </div>
        </div>
      </div>
    </header>

    <div class="container mt-5 content-scale">
      <router-view></router-view>
    </div>
    <div class="wrapper" v-if="stonky">
        <div v-for="index in 150" :key="`fry-${index}`" :class="`fry-${index}`"/>
        <div v-for="index in 5" :key="`burger-${index}`" :class="`burger-${index}`">
          <div class="bun-top"/>
          <div class="tomato"/>
          <div class="cheese"/>
          <div class="meat"/>
          <div class="lettuce"/>
          <div class="bun-bottom"/>
        </div>
    </div>
    <div class="wrapper" v-if="labz">
        <img v-for="index in 50" src="./assets/fud/labz-tight.png"  :key="`labz-${index}`" :class="`labz-${index}`"/>
        <img v-for="index in 20" src="./assets/fud/wojak-tight.png"  :key="`wojak-${index}`" :class="`wojak-${index}`"/>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const stonky = location.pathname === '/wage'
    const labz = location.pathname === '/labz'
    if (stonky) {
      document.body.classList.add("stonky-mode")
      this.$store.commit('setStonky')
    } else document.body.classList.remove("stonky-mode")
    if (labz) {
      document.body.classList.add("labz-mode")
      this.$store.commit('setLabz')
    } else document.body.classList.remove("labz-mode")
  },
  computed: {
    stonky: function() {
      return this.$store.state.stonky
    },
    labz: function() {
      return this.$store.state.labz
    }
  }
}
</script>

<style lang='scss'>
  .header-z {
    z-index: 1000;
  }
  .wrapper {
    z-index: 300;
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    pointer-events: none;
  }
  .fill-abs {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    transform: scale(1.5) rotate(-37deg);
  }
  .md-chart {
    position: absolute;
    opacity: 0.5;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    object-fit:contain;
  }

  
  
</style>